export const FACTIONS = {
  wei: { name: "魏", color: "#3f6ea5", dark: "#2b4d75", light: "#9db9d6" },
  shu: { name: "蜀", color: "#b03a2e", dark: "#7c2820", light: "#d99a90" },
  wu: { name: "吴", color: "#3d7a4f", dark: "#2a5537", light: "#98bfa3" },
  neutral: { name: "外邦", color: "#786b58", dark: "#514837", light: "#b9aa8f" },
  lvbu: { name: "吕布", color: "#9b4d32", dark: "#6c3024", light: "#d18c72" },
  yuan: { name: "袁绍", color: "#8b6f38", dark: "#5e4926", light: "#c9b477" },
  dong: { name: "董卓", color: "#754b78", dark: "#4d2e50", light: "#b990b9" },
  liubiao: { name: "刘表", color: "#4f7894", dark: "#345064", light: "#9abdd0" },
  kongrong: { name: "孔融", color: "#806b9b", dark: "#57476c", light: "#c2b2d6" },
  yuanshu: { name: "袁术", color: "#a06b35", dark: "#704a25", light: "#d5aa75" },
  gongsun: { name: "公孙瓒", color: "#6f8795", dark: "#4b5c66", light: "#afc1c9" },
  mateng: { name: "马腾", color: "#9a633d", dark: "#69432b", light: "#d0a17d" },
  zhanglu: { name: "张鲁", color: "#6b8b58", dark: "#475d3b", light: "#abc297" },
  liuzhang: { name: "刘璋", color: "#916b50", dark: "#634936", light: "#c9aa8f" },
  taoqian: { name: "陶谦", color: "#738f73", dark: "#4e624f", light: "#b0c3a9" },
  zhangxiu: { name: "张绣", color: "#9b5e6b", dark: "#6c414a", light: "#d0a0aa" },
  goguryeo: { name: "高句丽", color: "#5f7894", dark: "#405469", light: "#a4bed2" },
  baekje: { name: "百济", color: "#8b6b9b", dark: "#5f486b", light: "#c7acd4" },
  silla: { name: "新罗", color: "#a27b45", dark: "#70532f", light: "#d5b47b" },
  wa: { name: "倭国", color: "#9a5969", dark: "#6b3c49", light: "#d49aa8" },
  yizhou: { name: "夷洲", color: "#5e8b72", dark: "#3f604f", light: "#a4c9af" },
};

export const FAC_KEYS = ["wei", "shu", "wu"];
export const FOREIGN_FACTION_KEYS = ["goguryeo", "baekje", "silla", "wa", "yizhou"];
export const GRAND_FACTION_KEYS = ["wei", "shu", "wu", "dong", "lvbu", "yuan", "liubiao", "kongrong", "yuanshu", "gongsun", "mateng", "zhanglu", "liuzhang", "taoqian", "zhangxiu", ...FOREIGN_FACTION_KEYS];
export const GRAND_SUMMARY_FACS = [...GRAND_FACTION_KEYS, "neutral"];
export const FAC_HOTKEY = { wei: "1", shu: "2", wu: "3" };
